import api from "api/api";
export const createTypeCompanies = async (data) =>
  await api.post("/settings/type_company", data);

export const deleteTypeCompaniesById = async (id) =>
  await api.delete(`/settings/type_company/${id}`);

export const getTypeCompaniesById = async (id) =>
  await api.get(`/settings/type_company/${id}`);

export const getTypeCompaniesList = async () =>
  await api.get("/settings/type_company");

export const updateTypeCompaniesById = async (id, data) =>
  await api.put(`/settings/type_company/${id}`, data);
